export const defaultClientSortBy = "name_ASC";
export const defaultCampaignSortBy = "name_ASC";
